<template>
  <router-view />
</template>

<script>
export default {
  // La vérification de l'expiration du token est maintenant gérée par :
  // 1. Le router guard (à chaque navigation)
  // 2. L'interceptor HTTP (sur les réponses 401 de l'API)
};
</script>

<style lang="scss">
@import "src/assets/style/sass/variables";
#app {
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
input,
button,
select,
textarea {
  outline: none !important;
  &:focus,
  &:active {
    outline: none;
  }
}
</style>
